import { render, staticRenderFns } from "./policyFile.vue?vue&type=template&id=8ccfdd0a&scoped=true&"
import script from "./policyFile.vue?vue&type=script&lang=js&"
export * from "./policyFile.vue?vue&type=script&lang=js&"
import style0 from "./policyFile.vue?vue&type=style&index=0&id=8ccfdd0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccfdd0a",
  null
  
)

export default component.exports